import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'

// I18n - imports i18n-js and loads all translations into the singleton
import '../../app/frontend/translations.js'

// Set locale from the LOCALE global defined in the layout <script> tag
if (window.I18n && window.LOCALE) {
  window.I18n.locale = window.LOCALE
}

Rails.start()
Turbolinks.start()
ActiveStorage.start()
